"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualWalk = exports.Home = void 0;
var React = require("react");
var AppContext_1 = require("../AppContext");
var StyleComponents_1 = require("./base/StyleComponents");
var EventForm_1 = require("./EventForm");
var WineCarousel_1 = require("./WineCarousel");
var framer_motion_1 = require("framer-motion/dist/framer-motion");
var VideoSample = function () {
    var context = React.useContext(AppContext_1.AppContext);
    return (React.createElement("video", { style: {
            width: '100vw',
            height: 'calc(100vh + 100px)',
            objectFit: 'cover'
        }, poster: "image/1.jpg", preload: "none", loop: true, autoPlay: true, onLoadedData: function () { context.endLoad(); }, muted: true },
        React.createElement("source", { src: "video/winnica_swidnicka.mp4", type: "video/mp4" }),
        "Twoja przegl\u0105darka nie obs\u0142uguje wy\u015Bwietlania film\u00F3ws"));
};
var Overlay = function (props) {
    return (React.createElement("div", { style: {
            position: 'relative',
        } },
        React.createElement("div", { style: {
                width: '100%',
                height: 'calc(100% - 6px)',
                zIndex: 2,
                position: 'absolute',
                top: 0,
                left: 0,
                background: props.background //'linear-gradient(to bottom, transparent 60%,  white 90%)'
            } }),
        props.children));
};
var Home = function () {
    var context = React.useContext(AppContext_1.AppContext);
    React.useEffect(function () { context.startLoad(); }, []);
    return (React.createElement("div", { style: { position: 'relative', marginTop: -100 } },
        React.createElement(Overlay, { background: 'rgba(8,86,16,0.4)' },
            "          ",
            React.createElement("div", { style: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center' } },
                React.createElement("img", { style: { width: '80%', maxHeight: '50%', objectFit: 'contain' }, src: 'image/logo_cieniowane_pelne_male.png' })),
            React.createElement(VideoSample, null),
            React.createElement("div", { style: { position: 'absolute', bottom: 140, right: '10vw', zIndex: 4, color: 'white', opacity: .5, fontSize: 'calc(20px + 5vh)' } },
                React.createElement(framer_motion_1.motion.div, { animate: { y: 30 }, transition: {
                        repeat: 9999,
                        duration: 1,
                        repeatType: "reverse"
                    } },
                    React.createElement("img", { src: '/image/mouse.png', style: { height: 'calc(40px + 5vh)' } })))),
        React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', marginTop: -10 } },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1',
                    minWidth: 300,
                    minHeight: '75vh',
                    position: 'relative',
                    //zIndex: -2,
                    backgroundColor: 'black',
                    color: '#d1ab5c',
                    padding: '4em 4em 4em 4em',
                    textAlign: 'center'
                } },
                React.createElement("img", { src: '/image/gallery/1.jpg', style: { position: 'absolute', top: 0, zIndex: 1, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 } }),
                React.createElement("div", { style: { maxWidth: 300, zIndex: 2 } },
                    React.createElement(StyleComponents_1.FadeInWhenVisible, null,
                        React.createElement("h2", { style: { color: 'white' } },
                            React.createElement("b", null, "O NAS")),
                        React.createElement("hr", null),
                        React.createElement("p", null,
                            React.createElement("b", null, "Pe\u0142ni pasji od 2004 roku tworzymy polskie wina gronowe. Ich wysok\u0105 jako\u015B\u0107 zapewniamy poprzez r\u0119czny zbi\u00F3r, selekcj\u0119 gron oraz tradycyjne metody produkcji.")),
                        React.createElement("p", null,
                            React.createElement("b", null, "Winnica to r\u00F3wnie\u017C doskona\u0142e miejsce do wypoczynku, zwiedzania, degustacji oraz spotka\u0144 "))))),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1',
                    minWidth: 300,
                    minHeight: '75vh',
                    position: 'relative',
                    backgroundImage: 'linear-gradient(rgb(0,0,0,0.5) 0%, rgb(0,0,0,0.2) 100%), url("/image/gallery/11.jpg")',
                    backgroundSize: 'cover',
                    color: 'white',
                    padding: '1em 1em 1em 1em'
                } },
                React.createElement("div", { style: {
                        fontSize: 12,
                        color: 'floralWhite',
                        maxWidth: 300
                    } },
                    React.createElement(StyleComponents_1.FadeInWhenVisible, null,
                        React.createElement("h2", { style: { color: StyleComponents_1.goldColor } },
                            React.createElement("b", null, "O WINNICY")),
                        React.createElement("hr", { style: { width: '100%' } }),
                        React.createElement("p", null,
                            React.createElement("b", null, "Winnica znajduje si\u0119 nieopadal \u015Awidnicy, we wsi Makowice na Przedg\u00F3rzu Sudeckim. Zajmuje obszar 3,65 ha i usytuowana jest na czterech dzia\u0142kach o zr\u00F3\u017Cnicownym terroir.")),
                        React.createElement("p", null,
                            React.createElement("b", null, "Ju\u017C w \u015Bredniowieczu na okolicznych teranach uprawiano winoro\u015Bl, produkowano wino i regulowano nim p\u0142atno\u015Bci")),
                        React.createElement("p", null,
                            React.createElement("b", null, "Winnica po\u0142o\u017Cona na wysoko\u015Bci 255 m n.m.p i g\u00F3ruje nad najbli\u017Csz\u0105 okolic\u0105, st\u0105d te\u017C spacer po niej pozwala pozna\u0107 pi\u0119kne otoczenie \u015Awidnicy. Ze wzg\u00F3rz na kt\u00F3rych si\u0119 znajduje winnica, roztacza si\u0119 wspania\u0142y widok na panoram\u0119 miasta. Od strony wschodniej nad r\u00F3wnin\u0105 g\u00F3ruje Masyw \u015Al\u0119\u017Cy, od strony po\u0142udniowej G\u00F3ry Sowie z Wielk\u0105 Sow\u0105 na pierwszym planie, na zachodzie za\u015B mo\u017Cna dostrzec G\u00F3ry Wa\u0142brzyskie.")))))),
        React.createElement(WineCarousel_1.WineCarousel, null),
        React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1',
                    minWidth: 300,
                    minHeight: '75vh',
                    position: 'relative',
                    //zIndex: -2,
                    backgroundImage: 'linear-gradient(rgb(0,0,0,0.5) 0%, rgb(0,0,0,0.5) 100%), url("/image/gallery/7.jpg")',
                    backgroundSize: 'cover',
                    color: 'floralWhite',
                    padding: '4em 2em 4em 2em',
                    textAlign: 'center'
                } },
                React.createElement("div", { style: { maxWidth: 500, minWidth: 300, zIndex: 2, fontSize: 12, width: '50%' } },
                    React.createElement(StyleComponents_1.FadeInWhenVisible, null,
                        React.createElement("h2", { style: { color: StyleComponents_1.goldColor } },
                            React.createElement("b", null, "ENOTURYSTYKA")),
                        React.createElement("hr", null),
                        React.createElement("p", null,
                            React.createElement("b", null, "Poznanie i zrozumienia wina jest mo\u017Cliwe, gdy rozpoczniemy przygod\u0119 w miejscu jego narodzin \u2013 czyli na winnicy. Spotkania i rozmowy przy dobrym winie w otoczeniu winnicy to podstawowe cechy enoturystyki.")),
                        React.createElement("p", null,
                            React.createElement("b", null, "Na winnicy organizujemy przyj\u0119cia okoliczno\u015Bciowe: wesela, urodziny, wieczory panie\u0144skie / kawalerskie, imprezy firmowe i inne spotkania w wi\u0119kszym gronie. Na miejscu istnieje mo\u017Cliwo\u015B\u0107 wsp\u00F3lnego biesiadowania przy ognisku lub grillu, zapewnienie cateringu i dekoracji. A to wszystko oddalone od zgie\u0142ku, na wsi, na winnicy, w\u015Br\u00F3d zapachu winoro\u015Bli i pe\u0142ne wina. To co gdzie indziej jest zabronione \u2013 u nas staje si\u0119 mo\u017Cliwe.")),
                        React.createElement("p", null,
                            React.createElement("b", null, " Nasza winnica jest otwarta na przybycie indywidualnych go\u015Bci w sezonie od maja do pa\u017Adziernika. Aby odwiedzi\u0107 winnic\u0119 wi\u0119ksz\u0105 grup\u0105, zwiedzi\u0107 j\u0105 wraz z w\u0142a\u015Bcicielem, kt\u00F3ry opowie o winoro\u015Blach, produkcji win oraz otaczaj\u0105cych widokach \u2013 skontaktuj si\u0119 z nami poprzez formularz kontaktowy.")),
                        React.createElement("br", null),
                        React.createElement("a", { style: {
                                marginTop: '1em',
                                height: 65,
                                fontSize: 18,
                                color: 'floralWhite',
                                textDecorationLine: 'none',
                                border: '2px solid rgb(193, 135, 6)',
                                borderRadius: 30,
                                padding: '1em 1em 1em 1em'
                            }, href: "/oferta_enoturystyczna.pdf" }, "OFERTA ENOTURYSTYCZNA")))),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '1',
                    minWidth: 300,
                    minHeight: '75vh',
                    position: 'relative',
                    //zIndex: -2,
                    backgroundImage: 'linear-gradient(rgb(0,0,0,0.7) 0%, rgb(0,0,0,0.7) 100%), url("/image/gallery/3.jpg")',
                    backgroundSize: 'cover',
                    color: 'white',
                    padding: '1em 1em 1em 1em',
                } },
                React.createElement("div", { style: { textAlign: 'center' } },
                    React.createElement("span", { style: { color: 'white', letterSpacing: '.3em' } }, "Organizacja wydarze\u0144 i degustacji"),
                    React.createElement("h2", { style: { color: StyleComponents_1.goldColor, marginTop: '.5em', marginBottom: 0 } }, "FORMULARZ")),
                React.createElement("hr", { style: { width: '50%' } }),
                React.createElement(EventForm_1.EventForm, null))),
        React.createElement("div", { style: { height: 3 } })));
};
exports.Home = Home;
var VirtualWalk = function () {
    return (React.createElement("div", { className: "spacer_wrapper" },
        React.createElement("div", { style: { position: 'relative', paddingTop: '56%' } },
            React.createElement("iframe", { style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                }, height: "2", width: "2", src: "https://winnicedolnoslaskie.pl/spacer/winnice/swidnicka/", frameBorder: "0", allowFullScreen: true }))));
};
exports.VirtualWalk = VirtualWalk;
//# sourceMappingURL=Home.js.map